import React, { Component } from 'react'
import './Feedbackdetail.css'
import { Upload, Collapse, Modal } from 'antd'
import ScrollToTop from '../../../components/ScrollToTop'
import SubMenuSider from '../../../components/SubMenuSider'
import { Odata_Url, Odata_Filestream_Url, Constants } from '../../../Constants/Constants'

const Panel = Collapse.Panel;

function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

export default class Feedbackdetail extends Component {
    constructor() {
        super();

        this.state = {
            datafeedback: [],
            datauser: [],
            data_image: []
        };
    }

    componentWillMount() {
        const axios = require('axios');
        const feedid = this.props.location.state.feedid;

        axios.get(Constants.BASE_URL + 'auth/token').then((tokenRes) => {
            let token = tokenRes.data;
            let tokenHeader = { 
                headers: { 
                    "Authorization": "Bearer " + token
                } 
            };
            axios.get("api/Feedback?id=" + feedid, tokenHeader).then(response => {
                let datafeedback = [response.data];
                if(datafeedback && datafeedback.length > 0 && datafeedback[0].attachments){
                    let imgIds = datafeedback[0].attachments.map(x => x.guid);
                    axios.post("api/FileApi/list", imgIds, tokenHeader).then(fileInfoRes => {
                        let dataImages = fileInfoRes.data;
                        dataImages.forEach(file => {
                            file.uid = file.id;
                            file.url = "file/dist/" + file.fileNameUnique;
                        });
                        this.setState({
                            data_image: dataImages
                        });
                    });
                }
                this.setState({
                    datafeedback: datafeedback
                });
            });
        });
    }
    set_image(image) {
        this.setState({
            data_image: image
        })
    }

    handleAttachFilePreview = async (file) => {
        let url = "";

        if (file.url) {
            url = file.url;
        }
        else {
            url = await getBase64(file.originFileObj);
        }

        this.setState({
            attachFilePreviewUrl: url,
            attachFilePreviewVisible: true,
        });
    };

    handleAttachFileCancel = () => {
        this.setState({
            attachFilePreviewUrl: undefined,
            attachFilePreviewVisible: false
        });
    };

    render() {
        let data_image = this.state.data_image ? this.state.data_image : [];
        const page = this.props.location.state.page
        // console.log(page)
        var { datafeedback } = this.state
        //console.log(datafeedback);
        const userid = localStorage.getItem('feedback');
        //this.state.datauser.map((l, i) => {
        //    userid.push(l.PK_UserID)
        //    return ("")
        //})
        var username = localStorage.getItem('feedback');
        //console.log(userid);

        return (
            <div>
                <ScrollToTop />
                <SubMenuSider title="Feedback Detail" path={page}>
                    <div style={{ margin: "5%" }}>
                        <div className="clearfix">
                            <div>
                                <Collapse bordered={false} defaultActiveKey={["1", "2", "3", "4", "5", "6"]}>

                                    {
                                        (data_image && data_image.length !== 0) ? <Panel header="Image(s)" key="1" showArrow={false}>
                                            <Upload
                                                beforeUpload={(file) => {
                                                    return false;
                                                }}
                                                listType="picture-card"
                                                showUploadList={{ showPreviewIcon: true, showRemoveIcon: false }}
                                                fileList={data_image}
                                                onPreview={this.handleAttachFilePreview}
                                            >
                                            </Upload>
                                            <Modal visible={this.state.attachFilePreviewVisible} footer={null} onCancel={this.handleAttachFileCancel}>
                                                <img alt="example" style={{ width: '100%' }} src={this.state.attachFilePreviewUrl} />
                                            </Modal>
                                        </Panel>
                                        : null
                                    }

                                    <Panel header="Date time" key="2" showArrow={false}>
                                        {
                                            datafeedback.map((l, i) => {
                                                return (
                                                    l.datetime.slice(8, 10) + "-" + l.datetime.slice(5, 7) + "-" + l.datetime.slice(0, 4) + "  " + l.datetime.slice(11, 16)
                                                )
                                            })
                                        }
                                    </Panel>
                                    <Panel header="Topic" key="3" showArrow={false}>
                                        {
                                            datafeedback.map((l, i) => {
                                                return (
                                                    l.topic
                                                )
                                            })
                                        }
                                    </Panel>
                                    <Panel header="Detail" key="4" showArrow={false}>
                                        {
                                            datafeedback.map((l, i) => {
                                                return (
                                                    l.detail
                                                )
                                            })
                                        }
                                    </Panel>
                                    <Panel header="Status" key="5" showArrow={false}>
                                        {
                                            datafeedback.map((l, i) => {
                                                return (
                                                    l.status
                                                )
                                            })
                                        }
                                    </Panel>

                                </Collapse>
                            </div>
                        </div>
                    </div>
                </SubMenuSider>
            </div>
        );
    }
}